interface VoucherCampaign {
    message: string;
    participatingDealers: string[];
}

export const MARKET_VOUCHER_CAMPAIGNS: {
    [marketCode: string]: { [voucherCode: string]: VoucherCampaign };
} = {
    ROU: {
        FORDSERVICE200: {
            message: 'Dealer participant campanie FORDSERVICE200',
            participatingDealers: [
                '10200',
                '10400',
                '10700',
                '10701',
                '10702',
                '10800',
                '10801',
                '10802',
                '10803',
                '11000',
                '11400',
                '11600',
                '11900',
                '12100',
                '12300',
                '12400',
                '13100',
                '13500',
                '13700',
                '13800',
                '14200',
                '14300',
                '14800',
                '14900',
                '14901',
                '15000',
                '15100',
            ],
        },
    },
};
